let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gkgbs")).then(() => parcelRequire('lewnL'));